export default "__VITE_ASSET__52f44b64__"